import React from 'react';
import {Link} from "react-router-dom";
import footerOne from "../../data/footer/footerOne.json";
import ScrollTop from "./ScrollTop";
import {FiFacebook, FiTwitter, FiInstagram, FiLinkedin} from "react-icons/fi";
import FloatingWhatsApp from 'react-floating-whatsapp'
import {FaTelegram} from "react-icons/all";

const footerItemOne = footerOne[0];
const footerItemTwo = footerOne[1];
const footerItemThree = footerOne[2];
const footerItemFour = footerOne[3];
const footerItemFive = footerOne[4];


const indexOneLink = (footerItemOne.quicklink);
const indexTwoLink = (footerItemTwo.quicklink);
const indexThreeLink = (footerItemThree.quicklink);
const indexFourLink = (footerItemFour.quicklink);

const FooterTwo = () => {
    return (
        <>
            <FloatingWhatsApp className={'zIndex'} styles={{zIndex: 999999}}
                              statusMessage='Typically replies within minutes' darkMode allowClickAway allowEsc
                              avatar='./images/logo/favicon2.png' notificationSound phoneNumber='+254713958492'
                              accountName='Mixon Softwares'/>
            <footer className="rn-footer footer-style-default variation-two">
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            {/* Start Single Widget  */}
                            <div className="col-lg-2 col-md-6 col-sm-6 col-12 text-lg-center">
                                <div className="rn-footer-widget">
                                    <h4 className="title">{footerItemOne.title}</h4>
                                    <div className="inner">
                                        <ul className="footer-link link-hover">
                                            {indexOneLink.map((data, index) => (
                                                <li key={index}><Link to={`${data.url}`}>{data.text}</Link></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Widget  */}

                            {/* Start Single Widget  */}
                            <div className="col-lg-2 col-md-6 col-sm-6 col-12 text-lg-center">
                                <div className="rn-footer-widget">
                                    <div className="widget-menu-top">
                                        <h4 className="title">{footerItemTwo.title}</h4>
                                        <div className="inner">
                                            <ul className="footer-link link-hover">
                                                {indexTwoLink.map((data, index) => (
                                                    <li key={index}><Link to={`${data.url}`}>{data.text}</Link></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Widget  */}

                            {/* Start Single Widget  */}
                            <div className="col-lg-2 col-md-6 col-sm-6 col-12 text-lg-center">
                                <div className="rn-footer-widget">
                                    <h4 className="title">{footerItemThree.title}</h4>
                                    <div className="inner">
                                        <ul className="footer-link link-hover">
                                            {indexThreeLink.map((data, index) => (
                                                <li key={index}><Link to={`${data.url}`}>{data.text}</Link></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Widget  */}

                            {/* Start Single Widget  */}
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12 text-lg-center">
                                <div className="rn-footer-widget">
                                    <h4 className="title">{footerItemFour.title}</h4>
                                    <div className="inner">
                                        <ul className="footer-link link-hover">
                                            {indexFourLink.map((data, index) => (
                                                <li key={index}><Link to={`${data.url}`}>{data.text}</Link></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Widget  */}

                            {/* Start Single Widget  */}
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <h4 className="title">{footerItemFive.title}</h4>
                                    <div className="inner">
                                        <h6 className="subtitle">{footerItemFive.subtitle}</h6>
                                        <ul className="social-icon social-default justify-content-start">
                                            <li><a href="https://www.facebook.com/mixonsoftwares/"
                                                   target="_blank"><FiFacebook/></a></li>
                                            <li><a href="https://twitter.com/mixonsoftwares/"
                                                   target="_blank"><FiTwitter/></a></li>
                                            <li><a href="https://www.instagram.com/mixonsoftwares/"
                                                   target="_blank"><FiInstagram/></a></li>
                                            <li><a href="https://www.linkedin.com/company/mixonsoftwares/"
                                                   target="_blank"><FiLinkedin/></a></li>
                                            <li><a href="https://www.linkedin.com/company/mixonsoftwares/"
                                                   target="_blank"><FaTelegram/></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Widget  */}
                        </div>
                    </div>
                </div>
            </footer>
            <ScrollTop/>
        </>
    )
}

export default FooterTwo;
